import {
    PatientActions,
    PatientAllowCommunication,
    PatientEmail,
    PatientName,
    PatientPhone,
} from "./BulkRequestColumnComponents";
import { type StrictlyBasisPoints, stringFromBasisPoints } from "@vyne-shared/utils/currency";
import { balanceMap } from "../balanceMap";
import type { BulkRequestRecord } from "api/clients/useBulkRequestQuery";
import type { ColumnType } from "antd/es/table";
import type { SaveCallback } from "../useChangeOverlay";

function compareName(a: BulkRequestRecord, b: BulkRequestRecord) {
    return getSortableName(a).localeCompare(getSortableName(b));
}

function compareAgeThenName(a: BulkRequestRecord, b: BulkRequestRecord) {
    return a.idx - b.idx;
}

const staticColumns: ColumnType<BulkRequestRecord>[] = [
    {
        title: "Guarantor Name",
        dataIndex: "fullName",
        sorter: compareName,
        render: (_, record) => <PatientName record={record} />,
    },
    {
        title: "Phone/Email",
        ellipsis: {
            showTitle: false,
        },
        render: (_, record) => (
            <div className="bulk-request-contact-info">
                <PatientPhone record={record} />
                <PatientEmail record={record} />
            </div>
        ),
    },
    {
        title: "Aging",
        dataIndex: "balanceAge",
        defaultSortOrder: "descend",
        width: "10%",
        sorter: compareAgeThenName,
        render: (_, record) => balanceMap[record.balanceAge].title,
    },
    {
        title: "Requesting",
        dataIndex: "amount",
        sorter: (a, b) => a.amount - b.amount,
        render: (value: StrictlyBasisPoints) => stringFromBasisPoints(value),
        responsive: ["lg"],
    },
    {
        title: "Allow Contact",
        dataIndex: "allowCommunication",
        align: "center",
        width: "10%",
        render: (_, record) => <PatientAllowCommunication record={record} />,
    },
];

/** Definitions for columns for the Bulk Request table. */
export function getBulkRequestColumns(save: SaveCallback): ColumnType<BulkRequestRecord>[] {
    return [
        ...staticColumns,
        {
            title: "Actions",
            align: "center",
            width: "15%",
            render: (_, record) => <PatientActions record={record} save={save} />,
        },
    ];
}

function getSortableName(record: BulkRequestRecord) {
    return `${record.familyName}, ${record.givenName}`;
}
